import Bouncer from "formbouncerjs/dist/bouncer.js";

const locale = document.querySelector("html").getAttribute("lang");

// Define error messages by lang
const messages = {
  fr: {
    messages: {
      missingValue: {
        checkbox: "Ce champ est requis.",
        radio: "Veuillez sélectionner une valeur.",
        select: "Veuillez sélectionner une valeur.",
        "select-multiple": "Veuillez sélectionner au moins une valeur.",
        default: "Veuillez remplir ce champ."
      },
      patternMismatch: {
        email: "Veuillez entrer une adresse courriel valide.",
        url: "Veuillez entrer une URL.",
        number: "Veuillez entrer un nombre.",
        color: "Veuillez respecter le format suivant : #rrggbb",
        date: "Veuillez utiliser le format AAAA-MM-JJ.",
        time: "Veuillez utiliser le format horaire de 24 heures. Ex. 23:00",
        month: "Veuillez utiliser le format AAAA-MM.",
        default: "Veuillez respecter le format demandé."
      },
      outOfRange: {
        over: "Veuillez sélectionner une valeur qui ne dépasse pas {max}.",
        under:
          "Veuillez sélectionner une valeur qui n'est pas inférieure à {min}."
      },
      wrongLength: {
        over: "Veuillez raccourcir ce texte à {maxLength} caractères maximum. Vous utilisez actuellement {length} caractères.",
        under:
          "Veuillez allonger ce texte à {minLength} caractères ou plus. Vous utilisez actuellement {length} caractères."
      }
    }
  },
  en: {
    messages: {
      missingValue: {
        checkbox: "This field is required.",
        radio: "Please select a value.",
        select: "Please select a value.",
        "select-multiple": "Please select at least one value.",
        default: "Please fill out this field."
      },
      patternMismatch: {
        email: "Please enter a valid email address.",
        url: "Please enter a URL.",
        number: "Please enter a number",
        color: "Please match the following format: #rrggbb",
        date: "Please use the YYYY-MM-DD format",
        time: "Please use the 24-hour time format. Ex. 23:00",
        month: "Please use the YYYY-MM format",
        default: "Please match the requested format."
      },
      outOfRange: {
        over: "Please select a value that is no more than {max}.",
        under: "Please select a value that is no less than {min}."
      },
      wrongLength: {
        over: "Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.",
        under:
          "Please lengthen this text to {minLength} characters or more. You are currently using {length} characters."
      }
    }
  }
};

// Initialize form validator
const validate = new Bouncer("form:not(hidden)", {
  fieldClass: "etc-error",
  errorClass: "etc-error-message",
  fieldPrefix: "etc-field_",
  errorPrefix: "etc-error_",
  messageAfterField: true,
  messageCustom: "data-etc-message",
  messageTarget: "data-etc-target",
  ...messages[locale]
});

document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  if (params.has("program")) {
    const program = params.get("program");
    const select = document.querySelector('select[name="program"]');

    if (!select) return;
    select.value = program;
  }
});
